module.exports = __webpack_public_path__ + "media/packs/images/partners/partner-logo3-5e87c636b4415b2d0a7c49cfc08935fb.png";